<template>
  <div class="filtering-facets" :class="{ sticky: showSticky }">
    <div ref="el" class="grid-x grid-margin-x">
      <div class="cell small-12 medium-9">
        <FacetsList />
        <SelectedFacets />
      </div>

      <div class="cell medium-3 hide-for-small-only">
        <SortByCriteria />
      </div>
    </div>

    <SortAndFilter />
  </div>
</template>

<script setup>
import { useResizeObserver } from '@vueuse/core';
import useFacetOptions from '~/composables/filteringFacets/useFacetOptions';
import useDisplay from '~/composables/filteringFacets/useDisplay';
import { useFilteringFacetsStore } from '~/stores/filteringFacets';
import FacetsList from '~/components/FilteringFacets/FacetsList';
import SortByCriteria from '~/components/FilteringFacets/SortByCriteria';
import SelectedFacets from '~/components/FilteringFacets/SelectedFacets';
import SortAndFilter from '~/components/FilteringFacets/SortAndFilter';
import { GET_ALL_SELECTED_CRITERIA, ADD_FACET_OPTIONS, ADD_SORT_BY_OPTIONS } from '~/types/actions';
import useScrollSticky from '~/composables/filteringFacets/useScrollSticky';

const onlyMobile = true;
const scrollDir = 'up';
const { showSticky } = useScrollSticky(onlyMobile, scrollDir);

const filteringFacetsStore = useFilteringFacetsStore();
const props = defineProps({
  facets: {
    type: Array,
    required: true,
  },
  sortBy: {
    type: Array,
    required: true,
  },
});
const allSelectedCriteria = computed(() => filteringFacetsStore.allSelectedCriteria);

const el = ref(null);
const emit = defineEmits(['selectedCriteria']);

const { updateFacetsFilter } = useFacetOptions();
const { updateDisplay } = useDisplay();

const unsubscribe = filteringFacetsStore.$onAction(({ name, after }) => {
  after(() => {
    if (name === GET_ALL_SELECTED_CRITERIA) {
      emit('selectedCriteria', {
        allSelected: allSelectedCriteria.value,
      });
    }
  });
});
filteringFacetsStore[ADD_FACET_OPTIONS]({
  facets: props.facets,
});
filteringFacetsStore[ADD_SORT_BY_OPTIONS]({
  sortBy: props.sortBy,
});
onMounted(() => {
  useResizeObserver(el, () => {
    updateDisplay();
    updateFacetsFilter(filteringFacetsStore);
  });
});

onUnmounted(() => {
  unsubscribe();
});
</script>

<style lang="scss">
// import without scoped on purpose
@import '@csgIcons/_utility-filter.scss';
</style>

<style lang="scss" scoped>
.sticky {
  position: sticky;
  z-index: 20;
  background: $white;
  top: 0;
}
</style>
